import type { NavServiceLogFilterMode } from "lib/utils/filterNavServiceLogLines";

type NavLogFilterModeToggleProps = {
    mode: NavServiceLogFilterMode;
    onChange: (mode: NavServiceLogFilterMode) => void;
    className?: string;
};

const CheckIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden className="block">
        <path
            fill="currentColor"
            d="M4.6 9.2 1.4 6l1.1-1.1 2.1 2.1 4.1-4.5L9.8 3.6 4.6 9.2z"
        />
    </svg>
);

const BarsIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden className="block">
        <path
            fill="currentColor"
            d="M2.5 1.5h1.2v9H2.5zm3.4 0h1.2v9H5.9zm3.4 0h1.2v9H9.3z"
        />
    </svg>
);

const CrossIcon = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden className="block">
        <path
            fill="currentColor"
            d="M1.1.2 5 4.1 8.9.2l.9.9L5.9 5l3.9 3.9-.9.9L5 5.9.2 9.8l-.9-.9L4.1 5 .2 1.1z"
        />
    </svg>
);

/**
 * Single clickable toggle for filter-in / filter-out.
 * - Include: green ✓ | light |||
 * - Exclude: light ||| | dark ✕
 */
const NavLogFilterModeToggle = ({
    mode,
    onChange,
    className = "",
}: NavLogFilterModeToggleProps) => {
    const isInclude = mode === "in";

    return (
        <button
            type="button"
            aria-pressed={isInclude}
            aria-label={
                isInclude
                    ? "Filter in (showing matches). Click to filter out."
                    : "Filter out (hiding matches). Click to filter in."
            }
            title={isInclude ? "Filter in — click for filter out" : "Filter out — click for filter in"}
            className={`inline-flex h-7 shrink-0 overflow-hidden rounded-sm border border-black70 ${className}`}
            onClick={() => onChange(isInclude ? "out" : "in")}
            onPointerDown={(e) => e.stopPropagation()}
        >
            {isInclude ? (
                <>
                    <span className="flex h-full w-8 items-center justify-center bg-[#5a6b52] text-white">
                        <CheckIcon />
                    </span>
                    <span className="flex h-full w-8 items-center justify-center bg-[#d4d4d4] text-black70">
                        <BarsIcon />
                    </span>
                </>
            ) : (
                <>
                    <span className="flex h-full w-8 items-center justify-center bg-[#d4d4d4] text-black70">
                        <BarsIcon />
                    </span>
                    <span className="flex h-full w-8 items-center justify-center bg-black100 text-black40">
                        <CrossIcon />
                    </span>
                </>
            )}
        </button>
    );
};

export default NavLogFilterModeToggle;
